// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__RyMb_"};